import { Suspense, lazy } from "react";
import t from "prop-types";
import { Route, Switch } from "react-router-dom";
import FullScreenLoading from "@app/common/components/FullScreenLoad";

const ResourcePage = lazy(() => import("./components/Resource"));


const propTypes = {
  match: t.object,
};

const ResourcesRoutes = props => (
  <Switch>
    <Route
      exact
      path={`${props.match.path}/:resources_id`}
      render={innerProps => (
        <Suspense fallback={<FullScreenLoading />}>
          <ResourcePage {...innerProps} />
        </Suspense>
      )}
    />
  </Switch>
);

ResourcesRoutes.propTypes = propTypes;

export default ResourcesRoutes;
